export default __webpack_public_path__ + "static/Circular-Std-Book-ce1731670f4779d9c951d7c2f0727f36.ttf";